/*
 * QR codes drawn by the console itself (SPEC decision 28: no external QR service ever sees an install link). `uqr`
 * (MIT, unjs, no dependencies) encodes; this turns its module matrix into one SVG path, a run of dark modules per
 * `h` segment so a 150-character link stays a few kilobytes. Error correction M (15 %) and a 4-module quiet zone, as the
 * QR specification asks for reliable scanning from a screen.
 */
import { encode } from 'uqr';

export interface QrShape {
  /** Modules per side, quiet zone included (the SVG viewBox). */
  size: number;
  /** One path of 1-module-high runs of dark modules. */
  path: string;
}

export const QR_QUIET_ZONE = 4;

/** The dark runs of one row as path segments. */
function rowPath(row: readonly boolean[], y: number): string {
  let out = '';
  let x = 0;
  while (x < row.length) {
    if (!row[x]) { x += 1; continue; }
    const start = x;
    while (x < row.length && row[x]) x += 1;
    out += `M${start} ${y}h${x - start}v1h-${x - start}z`;
  }
  return out;
}

export function qrShape(text: string): QrShape {
  const { size, data } = encode(text, { ecc: 'M', border: QR_QUIET_ZONE });
  return { size, path: data.map((row, y) => rowPath(row, y)).join('') };
}
